import { SITE_URL, SITE_NAME, LOGO_PATH, OG_IMAGE_PATH, SUPPORT_EMAIL, PUBLISHER, TAGLINE, LANGS, LEGAL_POSTAL, TARGET_KEYWORDS, absoluteUrl, pagePath } from './seoConfig.mjs';

/** Flat, comma separated keyword list for JSON-LD (primary + secondary clusters). */
export const jsonLdKeywords = (lang) => {
  const k = TARGET_KEYWORDS[lang] || TARGET_KEYWORDS.fr;
  return [...k.primary, ...k.secondary].join(', ');
};

export const organizationSchema = (lang) => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  legalName: PUBLISHER,
  url: SITE_URL,
  logo: absoluteUrl(LOGO_PATH),
  image: absoluteUrl(OG_IMAGE_PATH),
  description: TAGLINE[lang],
  email: SUPPORT_EMAIL,
  knowsAbout: (TARGET_KEYWORDS[lang] || TARGET_KEYWORDS.fr).primary,
  address: { '@type': 'PostalAddress', ...LEGAL_POSTAL },
  contactPoint: [{ '@type': 'ContactPoint', contactType: 'customer support', email: SUPPORT_EMAIL, availableLanguage: ['French', 'English'] }],
});

export const websiteSchema = (lang) => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_URL,
  inLanguage: LANGS,
  description: TAGLINE[lang],
  keywords: jsonLdKeywords(lang),
  publisher: { '@type': 'Organization', name: PUBLISHER },
});

export const softwareSchema = (lang) => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: SITE_NAME,
  applicationCategory: 'LifestyleApplication',
  operatingSystem: 'Web',
  url: absoluteUrl(pagePath('home', lang)),
  image: absoluteUrl(OG_IMAGE_PATH),
  description: TAGLINE[lang],
  inLanguage: lang,
  keywords: jsonLdKeywords(lang),
  offers: { '@type': 'Offer', price: '0', priceCurrency: 'EUR', description: lang === 'fr' ? 'Mode invit\u00e9 gratuit, sans inscription' : 'Free guest mode, no sign-up' },
  featureList: lang === 'fr'
    ? ['Coach IA conversationnel', 'Analyse photo sur 5 axes', 'Simulation avant/apr\u00e8s', 'Routine hebdomadaire PDF', 'Suivi de progression', 'Rappels par email']
    : ['Conversational AI coach', '5-axis photo analysis', 'Before/after simulation', 'Weekly PDF routine', 'Progress tracking', 'Email reminders'],
  publisher: { '@type': 'Organization', name: PUBLISHER },
});

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({ '@type': 'ListItem', position: i + 1, name: it.name, item: absoluteUrl(it.path) })),
});

export const faqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(f => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
});

export const articleSchema = ({ lang, headline, description, path, keywords, wordCountMinutes }) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline,
  description,
  inLanguage: lang,
  keywords,
  mainEntityOfPage: absoluteUrl(path),
  url: absoluteUrl(path),
  image: [absoluteUrl(OG_IMAGE_PATH)],
  datePublished: '2026-10-18',
  dateModified: '2026-10-18',
  timeRequired: wordCountMinutes ? `PT${wordCountMinutes}M` : undefined,
  author: { '@type': 'Organization', name: SITE_NAME, url: SITE_URL },
  publisher: { '@type': 'Organization', name: PUBLISHER, logo: { '@type': 'ImageObject', url: absoluteUrl(LOGO_PATH) } },
});
